export default __webpack_public_path__ + "static/cafe_36070-5581c23d3ae280920da57be2b14abd24.png";